import {MI} from "../init";
import {he, wi} from "../../framework/src/engine/madnes/madnes_variables";
import {WinViewer} from "./WinViewer";

/**
 * @constructor
 * @param {GameConfig} gameConfig
 * @returns {GameAssets}
 */
export function GameAssets(gameConfig) {

	/** @type {MadnesObject} */
	this.bg;

	/** @type {Object<string, MadnesObject>} */
	this._reelCovers = {};

	/** @type {GameConfig} */
	this.gameConfig = gameConfig;

	/** @type {MadnesGroup} */
	this.cloudsGroup;

	/** @type {Array<MadnesObject>} */
	this._clouds = [];

	/** @type {MadnesTween} */
	this._cloudsTween;

	/** @type {MadnesGroup} */
	this._fireRopesGroup;

	/** @type {Array<MadnesObject>} */
	this._ropes = [];
	/** @type {Array<MadnesObject>} */
	this._fireRopes = [];

	/** @type {MadnesGroup} */
	this._stormGroup;

	/** @type {MadnesObject} */
	this._sea;

	/** @type {Object<string, MadnesObject>} */
	this._preloads = {};

	/** @type {Array<MadnesTween>} */
	this.showFireRopesTweens = [];

	/** @type {Array<MadnesTween>} */
	this.hideFireRopesTweens = [];

	/** @type {WinViewer} */
	this._winViewer;

	/** @type {MadnesGroup} */
	this._winGroup;
};

GameAssets.prototype.createPreloads = function() {
	this._preloads["symbol_Wild"] = MI.addImg(MI.getWi() - 10, MI.getHe() - 10, "symbol_Wild_atlas");

};

GameAssets.prototype.killPreloads = function() {
	for(var i in this._preloads) {
		this._preloads[i].kill();
	}
};

GameAssets.prototype.revivePreloads = function() {
	for(var i in this._preloads) {
		this._preloads[i].revive();
	}
};

GameAssets.prototype.createReelsBg = function() {
	this.bg = MI.addImg(0, 0, "background"); //.setBlend("ADD");
};

GameAssets.prototype.createReelCover1 = function() {

	this._reelCovers["reels_cover_left"] = MI.addImg(0, 0, "reels_atlas").setFrameName("column").setAnchor(0, 0);
	this._reelCovers["reels_cover_right"] = MI.addImg(MI.getWi(), 0, "reels_atlas").setFrameName("column").setScale(-1, 1).setAnchor(0, 0);
};

GameAssets.prototype.createReelCover2 = function() {
	this._reelCovers["reels_cover_top"] = MI.addImg(0, 0, "reels_atlas").setFrameName("reels_cover_01");
	this._reelCovers["reels_cover_bottom"] = MI.addImg(0, MI.getHe(), "reels_atlas").setFrameName("reels_cover_02").setAnchor(0, 1);
};

/**
 * @param {boolean} bool
 */
GameAssets.prototype.visibleReelCover = function(bool) {
	for(var key in this._reelCovers) {
		this._reelCovers[key].setVisible(bool);
	}
};

GameAssets.prototype.createRopes = function() {

	for(var i = 0; i < 4; i++) {
		var r = MI.addImg(this.gameConfig.ropesPos[i + 1], 0, "reels_atlas").setFrameName("rope").setAnchor(0.5, 0);
		this._ropes.push(r);
	}
};

GameAssets.prototype.createNodes = function() {

	for(var i = 0; i < 4; i++) {
		var r = MI.addImg(this.gameConfig.ropesPos[i + 1], 650, "reels_atlas").setFrameName("cover_bandage").setAnchor(0.5, 0.5);

		if(i % 2 === 0) {
			r.setScale(-1, 1);
		}

		this._ropes.push(r);
	}
};

/**
 * @param {number=} y
 * @param {number=} scale
 */
GameAssets.prototype.createFireRopes = function(y, scale) {

	var yy = typeof y !== "undefined" ? y : -10;
	var sc = typeof scale !== "undefined" ? scale : 2;

	this._fireRopesGroup = MI.createGroup();

	for(var i = 0; i < 6; i++) {
		var x = this.gameConfig.ropesPos[i];
		this._fireRopes[i] = MI.addImg(x, yy, "fire_rope_atlas");
		this._fireRopes[i].createAnims();
		this._fireRopes[i].anims.add("fire", MI.generateFrameNames("fire-rope_", 0, 14, "", 5));
		this._fireRopes[i].setAnchor(0.5, 0);
		this._fireRopes[i].setScale(sc, sc);
		this._fireRopes[i].kill();
		this._fireRopesGroup.add(this._fireRopes[i]);
	}
};

GameAssets.prototype.showFireRopes = function() {
	var _self = this;

	for(var i = 0; i < this._fireRopes.length; i++) {

		this._fireRopes[i].anims.loop("fire");
		this._fireRopes[i].setAlpha(0);
		this._fireRopes[i].revive();

		var t = MI.addTween().to(this._fireRopes[i], { 'alpha': 1 }, {
			'duration': 200,
			'callback': function() {
				if(i === _self._fireRopes.length - 1) {
					_self.showFireRopesTweens.length = 0;
				}
			}
		});

		this.showFireRopesTweens.push(t);
	}
};

GameAssets.prototype.hideFireRopes = function() {
	var _self = this;
	for(var i = 0; i < this._fireRopes.length; i++) {
		(function(i) {
			var t = MI.addTween().to(_self._fireRopes[i], { 'alpha': 0 }, {
				'duration': 200,
				'callback': function() {
					_self._fireRopes[i].anims.stop();
					_self._fireRopes[i].kill();

					if(i === _self._fireRopes.length - 1) {
						_self.hideFireRopesTweens.length = 0;
					}
				}
			});

			_self.hideFireRopesTweens.push(t);

			/*_self._ropes[i].setAlpha(0);
			_self._ropes[i].revive();

			MI.addTween().to(_self._ropes[i], { 'alpha': 1 }, {
				'duration': 400
			});*/
		} (i));
	}
};

GameAssets.prototype.destroyFireRopes = function() {

	for(var i = 0; i < this.showFireRopesTweens.length; i++) {
		this.showFireRopesTweens[i].destroy();
	}

	this.showFireRopesTweens.length = 0;

	for(var i = 0; i < this.hideFireRopesTweens.length; i++) {
		this.hideFireRopesTweens[i].destroy();
	}

	this.hideFireRopesTweens.length = 0;

	for(var i = 0; i < this._fireRopes.length; i++) {
		this._fireRopes[i].destroy();
	}
	this._fireRopes.length = 0;

	this._fireRopesGroup.destroy();
};

GameAssets.prototype.createClouds = function() {

	var w = wi - 2 * 60;

	this.cloudsGroup = MI.addGroup();

	this._clouds[0] = MI.addImg(40, 180, "reels_atlas").setFrameName("cloud_03");
	this._clouds[1] = MI.addImg(40 + w, 180, "reels_atlas").setFrameName("cloud_03");
	this._clouds[2] = MI.addImg(40 + w * 2, 180, "reels_atlas").setFrameName("cloud_03");

	this._clouds[3] = MI.addImg(604, 244, "reels_atlas").setFrameName("cloud_03");
	this._clouds[4] = MI.addImg(604 + w, 244, "reels_atlas").setFrameName("cloud_03");
	this._clouds[5] = MI.addImg(604 + w * 2, 244, "reels_atlas").setFrameName("cloud_03");

	this._clouds[6] = MI.addImg(733, 390, "reels_atlas").setFrameName("cloud_02");
	this._clouds[7] = MI.addImg(733 + w, 390, "reels_atlas").setFrameName("cloud_02");
	this._clouds[8] = MI.addImg(733 + w * 2, 390, "reels_atlas").setFrameName("cloud_02");

	this._clouds[9] = MI.addImg(0, 400, "reels_atlas").setFrameName("cloud_01");
	this._clouds[10] = MI.addImg(0 + w, 400, "reels_atlas").setFrameName("cloud_01");
	this._clouds[11] = MI.addImg(0 + w * 2, 400, "reels_atlas").setFrameName("cloud_01");

	this._clouds[12] = MI.addImg(450, 440, "reels_atlas").setFrameName("cloud_01");
	this._clouds[13] = MI.addImg(450 + w, 440, "reels_atlas").setFrameName("cloud_01");
	this._clouds[14] = MI.addImg(450 + w * 2, 440, "reels_atlas").setFrameName("cloud_01");

	for(var i = 0; i < this._clouds.length; i++) {
		this._clouds[i].setAnchor(0.5, 0.5); //.setScale(2, 2);
		this.cloudsGroup.add(this._clouds[i]);
	}

	this._cloudsTween = MI.addTween().to(this.cloudsGroup, { 'x': -w }, {
		'duration': 60000,
		'count': -1
	});
};

GameAssets.prototype.createSea = function() {
	this._sea = MI.addImg(0, he, "sea_reels_menu_atlas").setAnchor(0, 1).setScale(2.5, 2.22);
	this._sea.createAnims();
	this._sea.anims.add("sea", MI.generateFrameNames("sea_reels_menu_", 0, 26, "", 5));
	this._sea.anims.loop("sea");
};

GameAssets.prototype.hideSea = function() {
	this._sea.anims.stop();
	this._sea.kill();
};

GameAssets.prototype.showSea = function() {
	this._sea.revive();
	this._sea.anims.loop("sea");
};

GameAssets.prototype.killClouds = function() {
	for(var i = 0; i < this._clouds.length; i++) {
		this._clouds[i].kill();
	}
};

GameAssets.prototype.reviveClouds = function() {
	for(var i = 0; i < this._clouds.length; i++) {
		this._clouds[i].revive();
	}
};

GameAssets.prototype.stopClouds = function() {
	this._cloudsTween.pause();
};

GameAssets.prototype.playClouds = function() {
	//this.cloudsGroup.setPosX(0);
	this._cloudsTween.resume();
};

GameAssets.prototype.createFsGroup = function() {
	this._fsGroup = MI.addGroup();
};

GameAssets.prototype.destroyFsGroup = function() {
	this._fsGroup.destroy();
};

/**
 * @returns {MadnesGroup}
 */
GameAssets.prototype.getFsGroup = function() {
	return this._fsGroup;
};

GameAssets.prototype.createStormGroup = function() {
	this._stormGroup = MI.addGroup();
};

/**
 * @returns {MadnesGroup}
 */
GameAssets.prototype.getStormGroup = function() {
	return this._stormGroup;
};

GameAssets.prototype.createWinViewer = function() {
	this._winGroup = MI.addGroup("win_group");
	this._winViewer = new WinViewer();
	this._winViewer.create(this._winGroup);
};

/** @returns {WinViewer} */
GameAssets.prototype.getWinViewer = function() {
	return this._winViewer;
};